<div class="container">
  <div class="card">
    <div class="card-body">
      <h1>Valamar Payment Journey</h1>
      <p class="text-secondary">Aplikacija je inicijalizirana i spremna za razvoj.</p>
    </div>
  </div>
</div>
